import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { getProDetails, returnCustomerName } from "../NextStopComplianceUtills";
import Tooltip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
import CustomerMergeIndicator from "../../../../common/CustomerMergeIndicator";

const styles = (theme) => ({
  subHeaderText: {
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    padding: "5px 0px 0px 28px",
  },
  redHeader: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    color: theme.deviationStopPopupColor,
  },
  leftPadding: {
    paddingLeft: "10px",
  },

  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "70%",
  },
  flexRow: {
    display: "flex",
  },
});

const RouteStopInfo = ({ classes, stopDetails }) => {
  const customerName = returnCustomerName(stopDetails.data);
  return (
    <React.Fragment>
      <div className={classes.flexRow}>
        <div className={classes.redHeader}>
          {stopDetails.stopSequence}
          {stopDetails.data.stopType === appConstants.STOP_TYPE.Delivery
            ? "D"
            : "P"}
        </div>
        <Tooltip title={<div>{customerName}</div>}>
          <div
            className={`${classes.redHeader} ${classes.leftPadding} ${classes.ellipsisText}`}
          >
            {customerName}
          </div>
        </Tooltip>
        <CustomerMergeIndicator
          displayCustomerName={stopDetails.data.displayCustomerName}
          customerName={stopDetails.data.name}
        />
      </div>
      <div className={classes.subHeaderText}>
        Pro ID:
        {getProDetails(stopDetails.data.shipments)}
      </div>
    </React.Fragment>
  );
};
export default compose(withStyles(styles))(RouteStopInfo);
